import { SVGProps, Ref, forwardRef } from 'react';

export const TinkoffBrandAltSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M1 1h14v7.04a5.06 5.06 0 0 1-2.526 4.377L8 15l-4.474-2.583A5.05 5.05 0 0 1 1 8.04z" fill="white" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.84 4.706v2.19c.3-.34.844-.568 1.467-.568h.676v2.546c0 .678-.184 1.27-.458 1.597h2.943c-.272-.327-.456-.919-.456-1.595V6.33h.676c.623 0 1.168.228 1.467.567V4.708H4.839z"
            fill="#333333"
        />
    </svg>
));
TinkoffBrandAltSize16Glyph.displayName = 'TinkoffBrandAltSize16Glyph';
